const ROUTE_DASHBOARD = '/dashboard';
const ROUTE_PLACEHOLDER_HELP = '/help';

export const generateUrl = (route: string, lang: string) => {
    return `/lang-${lang}/${route}`;
}

export default {
    ROUTE_DASHBOARD,
    ROUTE_PLACEHOLDER_HELP,
};